import { styled } from "@mui/system";
import COLORS from "../../../theme/Colors";
import FONTS_FAMILY from "../../../theme/FontsFamily";

import Background from "../../../assets/images/WelcomeImage.png";
import BackgroundTexture from "../../../assets/images/BackgroundPrimary.png";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  width: "100%",
  height:'100vh',
  background: `url(${Background})`,
  backgroundSize: "cover",
});

export const RightContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignSelf: "flex-start",
  alignItems: "center",
  minWidth: "400px",
  height:'100%',
  overflow:'auto',
  backgroundColor: COLORS.white,
  background: `url(${BackgroundTexture})`,
  //TODO mediaqueries for width
  "@media (min-width:320px)": {
    width: "100%",
  },
  "@media (min-width:768px)": {
    width: "50%",
  },
  "h1,h2,h3,p": {
    margin: 4,
  },
});


export const WhiteLine = styled("div")({
  display:'flex',
  maxWidth:'600px',
  width:'100%',
  height:'2px',
  margin: '3px',
  backgroundColor:COLORS.white,
});

export const FormContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "90%",
  alignSelf: "center",
  alignItems: "center",
  textAlign: "center",
  "h1,h2,h3,p": {
    margin: '8px',
  },
  h1: {
    color: COLORS.white,
    fontSize: "2.1em",
    fontWeight: "200",
  },
  h2: {
    color: COLORS.white,
    fontWeight: "300",
    letterSpacing: "2.5px",
    fontSize: "1.5em",
  },
  h3: {
    color: COLORS.white,
    fontSize: "1.3em",
    fontWeight: "300",
  },
});

export const LogoImage = styled("img")({
  objectFit: "cover",
  cursor: "pointer",
  filter: 'brightness(0) invert(1)',
  width: "200px",
  marginTop: "50px",
  height: "auto",
  display: "block",
});

export const MinLogo = styled("img")({
  width:'100%',
  maxWidth:'156px',
  objectFit: "contain",
  //filter: 'invert(100%) bightness(200%)'

     filter: 'brightness(0) invert(1)',
});

export const FoundationLogosContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-evenly",
  gap: 16,
  marginTop: "8px",
  marginBottom: "8px",

});

export const ButtonsContainer = styled("div")({
  marginTop: "8px",
  gap: "16px",
  justifyContent: "center",
  display: "flex",
  flexDirection: "row",
  width: "100%",
});
export const RightImg = styled("img")({
  flex: 1,
  objectFit: "cover",
  "@media (min-width:320px)": {
    display: "none",
  },
  "@media (min-width:768px)": {
    display: "block",
  },

  //   filter: 'brightness(0) invert(1)',
});
